// react
import { useEffect } from 'react';

// tracking
import { TrackingEvent, useTracking } from 'hooks';

// components
import CannotBookCallPage from '@karehero/llama/components/pages/CannotBookCall/CannotBookCall';

// hooks
import { useCareCircle } from 'hooks';

/**
 * CannotBookCall shows the CannotBookCallPage component.
 */
export const CannotBookCall = () => {
  // hooks
  const { careCircle } = useCareCircle();

  const { track } = useTracking();

  // effects
  useEffect(() => {
    track(TrackingEvent.BookCallFailed, {});
  }, [track]);

  return <CannotBookCallPage careCircle={careCircle} />;
};

export default CannotBookCall;
